<template>
  <tile-card
    avatar
    hoverBehavior
    :marginLeft="'-15px'"
    :borderRadius="'0px'"
    :elevation="'0'"
    :colorOnHover="'#efefef'"
    :icon="icon"
    :iconColor="'primary'"
    :title="chapter.title"
    :subtitle="chapter.description"
    titleStyle="font-size: 16px; font-weight: bold"
    :titleClass="'accent--text'"
    :backgroundColor="'white'"
    @click="didTapItem"
  ></tile-card>
</template>

<script>
import TileCard from '@/components/TileCard.vue';

export default {
  components: { TileCard },
  data: () => ({
    defaultIcon: 'insert_drive_file',
  }),
  props: {
    chapter: {
      type: Object,
    },
  },
  methods: {
    didTapItem() {
      this.$router.push({
        name: 'chapter',
        params: { chapterID: this.chapter.id },
      });
    },
  },
  computed: {
    icon() {
      return this.chapter.icon || this.defaultIcon;
    },
  },
};
</script>
